import VueRouter, { RouteConfig } from 'vue-router'

const Index = () => import('../views/activity/jumprope-device-preview/Index.vue')
const LeadsCollectionSuccess = () => import('../views/activity/jumprope-device-preview/LeadsCollectionSuccess.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/jumprope-device-preview',
  name: 'activity_jumprope_device_preview',
  component: Index,
  meta: {
    title: '跳绳预告',
    ignoreLogin: true,
  },
}

export const leadsCollectionSuccessRoute: RouteConfig = {
  path: '/activity/jumprope-device-preview/leads-collection-success',
  name: 'activity_jumprope_device_preview_leads_collection_success',
  component: LeadsCollectionSuccess,
  meta: {
    title: '预约成功',
    ignoreLogin: true,
  },
}

export default [indexRoute, leadsCollectionSuccessRoute]

export function navigateToJumpropeDevicePreviewLeadsCollectionSuccess(router: VueRouter) {
  router.push({ name: leadsCollectionSuccessRoute.name })
}
